import { useDispatch, useSelector } from "react-redux";
import AdminProfileBody from "./ProfileBody";
import { useEffect, useState } from "react";
import SideBar from "../../Users/common/SideBar";
import HeaderBar from "../../Users/common/HeaderBar";
// import { profileCompletionPercentage } from "../../../../Redux/profile/profile.action";

const AdminProfilePage = () => {
  // const dispatch = useDispatch();
  // const [showSidebar, setShowSidebar] = useState(false);
  // const profileCompletion = useSelector(
  //   (state) => state?.ProfileManager?.completion?.profile_completion
  // );
  // useEffect(() => {
  //   dispatch(profileCompletionPercentage());
  // }, [dispatch]);

  // useEffect(() => {
  //   if (profileCompletion > 80) {
  //     setShowSidebar(true);
  //   } else {
  //     setShowSidebar(false);
  //   }
  // }, [profileCompletion]);

  // const handleProfileSuccess = () => {
  //   setShowSidebar(true);
  // };

  return (
    <main className="ff2 main-page">
      <HeaderBar />
      <div className="overflow-hidden inner-page-content ">
         <SideBar />
        {/* <AdminProfileBody onProfileUpdateSuccess={handleProfileSuccess} /> */}
         <AdminProfileBody />
      </div>
    </main>
  );
};

export default AdminProfilePage;
